const state = {
  window: {
    show: false,
    text: "",
    color: "",
  },
  snackbar: {
    show: false,
    text: "",
    html: "",
    color: "",
    timeout: 2000,
  },
  unauthorized: false,
  not_found: false,
};

const mutations = {
  SHOW_DIALOG(
    state: { window: { show: boolean; text: any; color: any } },
    payload: { text: any; color: any }
  ) {
    state.window.show = true;
    state.window.text = payload.text;
    state.window.color = payload.color;
  },
  SHOW_SNACKBAR(
    state: { snackbar: { show: boolean; text: any; color: any; timeout: any, html: any } },
    payload: { text: any; color: any; timeout: any, html: any }
  ) {
    state.snackbar.show = true;
    state.snackbar.text = payload.text;
    state.snackbar.html = payload.html;
    state.snackbar.color = payload.color;
    state.snackbar.timeout = payload.timeout;
  },
  SHOW_NOT_FOUND() {
    state.not_found = true;
  },
  HIDE_NOT_FOUND() {
    state.not_found = false;
  },
  SHOW_UNAUTHORIZED() {
    state.unauthorized = true;
  },
  HIDE_UNAUTHORIZED() {
    state.unauthorized = false;
  }
};

const getters = {
  get_not_found(state: { not_found: any }) {
    return state.not_found;
  },
};

export const ui = {
  namespaced: true,
  state,
  mutations,
  getters,
};
